<!-- src/components/NotesEntry.vue -->

<template>
    <article class="note-entry" @click="$emit('click', article)">
        <h3 class="note-entry-title">{{ note.project.title }}</h3>
        <span class="note-entry-id">{{ note.project.id }}</span>
        <span class="note-entry-location">{{ note.project.city }}, {{ note.project.state }}</span>
        <span class="note-entry-date">{{ note.created_at | moment("MM/DD/YYYY") }}</span>
        <p class="note-entry-body">{{ note.note }}</p>
    </article>
</template>

<script>
export default {
    props: ['note'],
    computed: {
        shortenedBody: function() {
            var length = 300,
                isTooLong = this.article.body.length > length,
                s_ = isTooLong ? this.article.body.substr(0, length-1) : this.article.body;
                s_ = isTooLong ? s_.substr(0, s_.lastIndexOf(' ')) : s_;
            return  isTooLong ? s_ + '...' : s_;
        }
    }
}
</script>
